import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchProducts } from 'src/api/products';
import { FETCH_PRODUCTS, requestProducts, requestProductsFailure, requestProductsSuccess } from './actions';

function* fetchProductsSaga(action: AnyAction): SagaIterator {
    yield put(requestProducts());

    const { error, response } = yield call(fetchProducts, action.productGroup, action.excludeSetProducts, action.name);

    if (error) {
        yield put(requestProductsFailure(error));
    } else {
        yield put(requestProductsSuccess(response));
    }
}

export function* generateFetchProducts() {
    yield takeLatest(FETCH_PRODUCTS, fetchProductsSaga);
}
